<div
  class="ui-bottom-sheet-backdrop"
  *ngIf="open"
  [style.opacity]="backdropOpacity"
  (click)="close()"
></div>

<div
  #sheet
  class="ui-bottom-sheet"
  role="dialog"
  aria-modal="true"
  [hidden]="!open"
  [attr.aria-hidden]="!open"
  [attr.aria-label]="title || closeAriaLabel"
  [class.is-dragging]="dragging"
  [style.transform]="dragOffset ? 'translateY(' + dragOffset + 'px)' : null"
  [style.--ui-bottom-sheet-max-width]="maxWidth"
>
  <div
    class="ui-bottom-sheet-grab"
    (pointerdown)="onGrabStart($event)"
    (pointermove)="onGrabMove($event)"
    (pointerup)="onGrabEnd($event)"
    (pointercancel)="onGrabCancel()"
  >
    <div class="ui-bottom-sheet-handle-zone">
      <span class="ui-bottom-sheet-handle" aria-hidden="true"></span>
    </div>

    <div class="ui-bottom-sheet-header" [class.is-plain]="!title">
      <h2 class="ui-bottom-sheet-title" *ngIf="title">{{ title }}</h2>
      <button
        class="ui-bottom-sheet-close"
        type="button"
        [attr.aria-label]="closeAriaLabel"
        (click)="close()"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>

  <div class="ui-bottom-sheet-body" [class.is-muted]="mutedBody">
    <ng-content></ng-content>
  </div>

  <div class="ui-bottom-sheet-footer" [hidden]="!footer">
    <ng-content select="[uiBottomSheetFooter]"></ng-content>
  </div>
</div>
